import type { APIDependencies, HCInstance } from "../hc/types";
import type { deps } from "../api";
import * as dom from "../dom";

type ApiMap = Partial<{ [K in APIDependencies]: (typeof deps)[K] }>;

export class HCv4 implements HCInstance {
  private api: ApiMap;
  readonly dom = dom;

  constructor(apiDeps: ApiMap | null) {
    this.api = apiDeps ?? {};
  }

  private use<K extends APIDependencies>(dep: K): (typeof deps)[K] {
    const module = this.api[dep];
    if (!module) {
      throw new Error(
        `HCv4: "${dep}" was not provided as a dependency. Pass it when creating the instance: create("v4", ["${dep}"])`
      );
    }

    return module as (typeof deps)[K];
  }

  getAllArticles(): Promise<any> {
    const articles = this.use("articles");
    return articles.getAll();
  }

  searchForArticle(query: string): Promise<any> {
    const articles = this.use("articles");
    return articles.searchArticle(query);
  }
}
